function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.094 7.244A4 4 0 0 1 6.5 7c3.314 0 5.073 3.595 5.939 9.464a53.76 53.76 0 0 1 .491 5.346c.055 1.218.07 2.13.07 3.19 0 3.396-2.115 6-6.5 6S0 28.396 0 25c0-1.06.015-1.973.07-3.19a53.58 53.58 0 0 1 .491-5.346c.376-2.55.92-4.67 1.688-6.252.456-2.638.919-4.04 1.9-5.445C5.649 2.617 8.11 1.384 12 1c4.86 0 8.01 1.995 9.653 5.445C22.736 8.72 23 10.858 23 14h-2c0-2.858-.236-4.77-1.153-6.695C18.535 4.55 16.087 3 12.1 2.995c-4.04.404-5.91 1.45-7.005 4.25zM6.5 29c3.178 0 4.5-1.627 4.5-4a63.42 63.42 0 0 0-.068-3.099 51.626 51.626 0 0 0-.472-5.145C9.737 11.855 8.34 9 6.5 9c-1.84 0-3.237 2.855-3.96 7.756a51.629 51.629 0 0 0-.472 5.145A63.47 63.47 0 0 0 2 25c0 2.373 1.322 4 4.5 4zm23.206-10H29a2 2 0 0 1-2-2v-1h-6v-2h9.496a1.5 1.5 0 0 1 1.5 1.5v.023C31.882 22.998 29.214 27 24 27h-7v-2h7c3.117 0 5.017-1.91 5.706-6zM17 15a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
});

var SvgDog = function SvgDog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "cb2125f303d72b0a2f39c283b5ba30d2.svg";
export { SvgDog as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/dog.svg
// module id = null
// module chunks = 